// extracted by mini-css-extract-plugin
module.exports = {"service-filter-layout":"categories_service-filter-layout__4RELj"};